import React from "react";
import { Link } from "react-router-dom";
import LandingShell from "./LandingShell";
import HeroSection from "./sections/HeroSection";
import InteractiveDemoSection from "./sections/InteractiveDemoSection";
import WorkflowTeaser from "./sections/WorkflowTeaser";
import StatusSection from "./sections/StatusSection";
import FeatureDeepDive from "./sections/FeatureDeepDive";
import SocialProofSection from "./sections/SocialProofSection";
import useReveal from "./useReveal";
import { REGISTER_URL } from "./landingData";

const Landing = () => {
    useReveal();

    return (
        <LandingShell>
            <HeroSection />
            <InteractiveDemoSection />
            <WorkflowTeaser />
            <StatusSection />

            <section className="clk-section clk-section-features alt" id="features">
                <div className="clk-container">
                    <div className="clk-section-head clk-reveal">
                        <span className="clk-eyebrow"><span className="clk-dot" /> Features</span>
                        <h2>Tickets from everywhere, in one place.</h2>
                        <p>
                            Your support inbox, website forms, in-app requests, and API all stream
                            into one workspace. Pick a feature to see how it works.
                        </p>
                    </div>
                </div>
                <FeatureDeepDive />
            </section>

            <SocialProofSection />

            <section className="clk-section alt">
                <div className="clk-container">
                    <div className="clk-page-cta clk-reveal">
                        <div>
                            <h2>Ready to simplify your support?</h2>
                            <p>Start free today, or explore plans that grow with your team.</p>
                        </div>
                        <div className="clk-page-cta-actions">
                            <a className="clk-btn clk-btn-primary clk-btn-lg" href={REGISTER_URL}>
                                Start your free trial
                            </a>
                            <Link className="clk-btn clk-btn-ghost clk-btn-lg" to="/pricing">
                                View pricing
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </LandingShell>
    );
};

export default Landing;
